/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import Axios from "axios";

import APP_CONSTANTS from "../../config/constants";

const BillingPartyDropdown = (props) => {
  const [customerData, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialize, setInitialize] = useState(false);


  useEffect(() => {
    setIsLoading(true);
    let token = localStorage.getItem("apiToken");
    let userId = localStorage.getItem("userId");
    let customerNo = localStorage.getItem("customerNo");
    let data = JSON.stringify({
      customerNumber: customerNo,
      userId: userId,
      customer_no: customerNo,
      user_id: userId,
      customerNo: customerNo,
    });

    Axios.get(
      `${APP_CONSTANTS.BASE_URL}masters/billing_party?customerNumber=${customerNo}&userId=${userId}`,
      {
        params: {
          billingPartyCode: "",
        },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setCustomerData(response.data.resultSet);
        setIsLoading(false);
      })
      .catch((error) => console.log(error));
    setIsLoading(false);
  }, []);

  let options = [];
  if (customerData && customerData.length > 0) {
    customerData.map((object, index) => {
      let temp = {};
      temp.key = index;
      temp.text = object.billingPartyName;
      temp.value = object.billingPartyCode;
      return (options[index] = temp);
    });
  }

  const handleOnChange = (e, data) => {
    if (data.value) {
      let test = customerData.forEach((object) => {
        if (data.value == object.billingPartyCode) {
          props.getCustomerDetails(object);
        }
      });
    } else {
      props.getCustomerDetails(null);
    }
    setInitialize && setInitialize(true);
    props.selectOption(data.value);
    let token = localStorage.getItem("apiToken");
    let userId = localStorage.getItem("userId");
    let customerNo = localStorage.getItem("customerNo");

    let customerObject = customerData.filter((e) => {
      return e.billingPartyCode === data.value;
    });

    if (data.value) {
      Axios.get(
        `${APP_CONSTANTS.BASE_URL
        }masters/billing_party_branch/?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${customerObject &&
        customerObject?.length > 0 &&
        customerObject[0]?.billingPartyId
        } `,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      )
        .then((response) => {
          getBranchData(response.data.resultSet);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleSearchChange = (e, { searchQuery }) => {
    if (searchQuery.length > 1) {
      setIsLoading(true);
      let token = localStorage.getItem("apiToken");
      let userId = localStorage.getItem("userId");
      let customerNo = localStorage.getItem("customerNo");
      let data = JSON.stringify({
        customerNumber: customerNo,
        userId: userId,
        customer_no: customerNo,
        user_id: userId,
        customerNo: customerNo,
        searchString: searchQuery,
      });

      Axios.get(
        `${APP_CONSTANTS.BASE_URL}masters/billing_party?customerNumber=${customerNo}&userId=${userId}`,
        {
          params: {
            searchString: searchQuery,
          },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      )
        .then((response) => {
          setCustomerData(response.data.resultSet);
          setIsLoading(false);
        })
        .catch((error) => console.log(error));
      setIsLoading(false);
    }
  };

  return (
    <>
      {props?.selectValue ? (
        <Dropdown
          defaultValue={props?.selectValue}
          search
          selection
          onChange={(e, data) => handleOnChange(e, data)}
          onSearchChange={handleSearchChange}
          options={options}
          placeholder="Custmer Name"
          clearable
          style={{
            maxWidth: "fit-content",
            marginRight: "20px",
            fontSize: "11px",
          }}
          loading={isLoading}
          {...props}
          fluid
        />
      ) : (
        <Dropdown
          search
          selection
          onChange={(e, data) => handleOnChange(e, data)}
          onSearchChange={handleSearchChange}
          options={options}
          placeholder="Custmer Name"
          clearable
          style={{
            maxWidth: "fit-content",
            marginRight: "20px",
            fontSize: "11px",
          }}
          loading={isLoading}
          {...props}
          fluid
        />
      )}
    </>
  );
};

export default BillingPartyDropdown;
